<script setup lang="ts">

</script>

<template>
    <div class="dropdown-item">
        <slot />
    </div>
</template>